import { render, staticRenderFns } from "./GlobalFeatures.vue?vue&type=template&id=e4d60254&scoped=true"
import script from "./GlobalFeatures.vue?vue&type=script&lang=js"
export * from "./GlobalFeatures.vue?vue&type=script&lang=js"
import style0 from "./GlobalFeatures.vue?vue&type=style&index=0&id=e4d60254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d60254",
  null
  
)

export default component.exports